<template>
  <v-app class="landing-page">
    <nav>
      <v-navigation-drawer
        v-model="drawer"
        app
        temporary
        class="landing-drawer"
      >
        <v-list-item class="pb-2">
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ this.siteName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-item
            v-for="([icon, text, link], i) in items"
            :key="i"
            link
            @click="$vuetify.goTo(link)"
          >
            <v-list-item-icon class="justify-center">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="subtitile-1">
                {{ text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item @click="switchSignIn">
            <v-list-item-icon class="justify-center">
              <v-icon>login</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="subtitile-1">
                {{ $t("signIn") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar app elevation="14" class="landing-app-bar">
        <v-toolbar-title
          ><v-img :src="this.logoPath" max-height="50" max-width="70" contain
        /></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon
          v-if="isXs == true"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <div v-else>
          <v-btn
            text
            class="landing-nav-link"
            :class="{ 'nav-link-active': activeSection === 'home' }"
            @click="navigateToSection('home')"
            ><span class="text-capitalize">{{ $t("home") }}</span></v-btn
          >
          <v-btn
            v-if="this.itemsPlan.length > 0"
            text
            class="landing-nav-link"
            :class="{ 'nav-link-active': activeSection === 'pricing' }"
            @click="navigateToSection('pricing')"
            ><span class="text-capitalize">{{ $t("pricing") }}</span></v-btn
          >
          <v-btn
            text
            class="landing-nav-link"
            :class="{ 'nav-link-active': activeSection === 'features' }"
            @click="navigateToSection('features')"
            ><span class="text-capitalize">{{ $t("features") }}</span></v-btn
          >
          <v-btn
            text
            class="landing-nav-link"
            :class="{ 'nav-link-active': activeSection === 'contact' }"
            @click="navigateToSection('contact')"
            ><span class="text-capitalize">{{ $t("contact") }}</span></v-btn
          >
        </div>
        <v-spacer v-if="isXs == false"></v-spacer>
        <v-btn
          v-if="isXs == false"
          outlined
          @click="switchSignIn"
          class="text-capitalize landing-sign-in"
          >{{ $t("signIn") }}</v-btn
        >
      </v-app-bar>
    </nav>
    <v-main>
      <Message />
      <section id="home" class="landing-home">
        <v-row justify="center" class="homeMargin landing-hero">
          <v-col cols="10">
            <v-row>
              <v-col cols="12" md="6" align-self="center">
                <h1 class="header">{{ this.settingsObj.homeHeader1 }}</h1>
                <div class="bodyText">{{ this.settingsObj.homeDetail1 }}</div>
                <v-btn
                  outlined
                  @click="$vuetify.goTo('#pricing')"
                  class="text-capitalize"
                  >{{ $t("getRegister") }}</v-btn
                >
              </v-col>
              <v-col cols="12" md="6" align-self="start">
                <v-img
                  max-height="450"
                  max-width="900"
                  :src="getHomeImg"
                ></v-img>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" class="home-intro-title">
          <v-col cols="10" md="7">
            <h1 class="header text-center">
              {{ this.settingsObj.homeHeader2 }}
            </h1>
          </v-col>
        </v-row>
        <v-row justify="center" class="home-intro-detail">
          <v-col cols="10" md="10">
            <p class="bodyText text-center">
              {{ this.settingsObj.homeDetail2 }}
            </p>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-16 mb-16 home-highlights">
          <v-col cols="10">
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-card
                  shaped
                  elevation="16"
                  min-height="185px"
                  class="highlight-card"
                >
                  <v-card-title class="highlight-title white--text"
                    ><v-row justify="center">{{
                      this.settingsObj.homeBox1Header
                    }}</v-row></v-card-title
                  >
                  <v-card-text>{{
                    this.settingsObj.homeBox1Detail
                  }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card
                  shaped
                  elevation="16"
                  min-height="185px"
                  class="highlight-card"
                >
                  <v-card-title class="highlight-title white--text"
                    ><v-row justify="center">{{
                      this.settingsObj.homeBox2Header
                    }}</v-row></v-card-title
                  >
                  <v-card-text>{{
                    this.settingsObj.homeBox2Detail
                  }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card
                  shaped
                  elevation="16"
                  min-height="185px"
                  class="highlight-card"
                >
                  <v-card-title class="highlight-title white--text"
                    ><v-row justify="center">{{
                      this.settingsObj.homeBox3Header
                    }}</v-row></v-card-title
                  >
                  <v-card-text>{{
                    this.settingsObj.homeBox3Detail
                  }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card
                  shaped
                  elevation="16"
                  min-height="185px"
                  class="highlight-card"
                >
                  <v-card-title class="highlight-title white--text"
                    ><v-row justify="center">{{
                      this.settingsObj.homeBox4Header
                    }}</v-row></v-card-title
                  >
                  <v-card-text>{{
                    this.settingsObj.homeBox4Detail
                  }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>

      <section id="pricing" class="mt-16 mb-16 landing-section pricing-section">
        <v-row justify="center">
          <v-col cols="10">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-for="item in itemsPlan"
                :key="item.billingPlanId"
              >
                <v-card hover shaped outlined class="cardBorder pricing-card">
                  <v-card-title class="pt-12"
                    ><v-row justify="center">{{
                      item.title
                    }}</v-row></v-card-title
                  >
                  <v-card-subtitle class="text-center">{{
                    item.interval
                  }}</v-card-subtitle>
                  <v-card-subtitle class="text-center"
                    ><v-avatar color="grey darken-1" size="70"
                      ><span class="lime--text text-h5"
                        >${{ item.price }}</span
                      ></v-avatar
                    ></v-card-subtitle
                  >
                  <v-card-text class="py-8">
                    <v-row justify="center" class="black--text"
                      >{{ item.assessmentCount }} {{ $t("assessments") }}</v-row
                    >
                    <v-divider></v-divider>
                    <v-row justify="center" class="black--text"
                      >{{ item.responseAllAssessmentCount }}
                      {{ $t("responsesForAllAssessment") }}</v-row
                    >
                    <v-divider></v-divider>
                    <v-row justify="center" class="black--text"
                      >{{ item.responsePerAssessmentCount }}
                      {{ $t("responsesForEachAssessment") }}</v-row
                    >
                    <v-divider></v-divider>
                    <v-row justify="center" class="black--text">{{
                      item.additionalText
                    }}</v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-row justify="center" v-if="item.price > 0">
                      <form v-bind:action="stripePostUrl" method="POST">
                        <input
                          type="hidden"
                          name="billingId"
                          v-bind:value="item.billingPlanId"
                        />
                        <v-btn
                          type="submit"
                          :disabled="stripeKey == '' || stripeKey == null"
                          @click="saveBillingPlan(item)"
                          class="text-capitalize"
                          outlined
                          >{{ $t("subscribe") }}</v-btn
                        >
                      </form>
                    </v-row>
                    <v-row justify="center" v-else-if="item.price == 0"
                      ><v-btn
                        @click="saveBillingPlan(item)"
                        class="text-capitalize"
                        outlined
                        >{{ $t("subscribe") }}</v-btn
                      ></v-row
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>

      <section
        id="features"
        class="mt-16 mb-16 landing-section feature-section"
      >
        <v-row justify="center">
          <v-col cols="10">
            <v-row class="feature-row">
              <v-col cols="12" md="6" align-self="center" order="1">
                <v-card flat>
                  <v-card-title>
                    <h3 class="headerFeature">
                      {{ this.settingsObj.feature1Header }}
                    </h3>
                  </v-card-title>
                  <v-card-subtitle>
                    {{ this.settingsObj.feature1Detail }}
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" order="2">
                <v-img
                  max-width="500"
                  max-height="500"
                  :src="getFeature1Img"
                  contain
                ></v-img>
              </v-col>
            </v-row>
            <v-row class="feature-row">
              <v-col cols="12" md="6" order="2" order-md="1">
                <v-img
                  max-width="500"
                  max-height="500"
                  :src="getFeature2Img"
                ></v-img>
              </v-col>
              <v-col
                cols="12"
                md="6"
                align-self="center"
                order="1"
                order-md="2"
              >
                <v-card flat>
                  <v-card-title>
                    <h3 class="headerFeature">
                      {{ this.settingsObj.feature2Header }}
                    </h3>
                  </v-card-title>
                  <v-card-subtitle>
                    {{ this.settingsObj.feature2Detail }}
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="feature-row">
              <v-col cols="12" md="6" align-self="center" order="1">
                <v-card flat>
                  <v-card-title>
                    <h3 class="headerFeature">
                      {{ this.settingsObj.feature3Header }}
                    </h3>
                  </v-card-title>
                  <v-card-subtitle>
                    {{ this.settingsObj.feature3Detail }}
                  </v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" order="2">
                <v-img
                  max-width="500"
                  max-height="500"
                  :src="getFeature3Img"
                ></v-img>
              </v-col>
            </v-row>
            <v-row class="feature-row">
              <v-col cols="12" md="6" order="2" order-md="1">
                <v-img
                  max-width="500"
                  max-height="500"
                  :src="getFeature4Img"
                ></v-img>
              </v-col>
              <v-col
                cols="12"
                md="6"
                align-self="center"
                order="1"
                order-md="2"
              >
                <v-card flat>
                  <v-card-title>
                    <h3 class="headerFeature">
                      {{ this.settingsObj.feature4Header }}
                    </h3>
                  </v-card-title>
                  <v-card-subtitle>
                    {{ this.settingsObj.feature4Detail }}
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>

      <section id="register" class="mt-16 mb-16 landing-cta">
        <v-card class="white--text text-center cta-card" dark>
          <v-card-text class="pt-10">{{
            this.settingsObj.registrationText
          }}</v-card-text>
          <v-row class="pb-10" justify="center"
            ><v-card-actions
              ><v-btn
                @click="$vuetify.goTo('#pricing')"
                class="text-capitalize"
                outlined
                >{{ $t("registerNow") }}</v-btn
              ></v-card-actions
            ></v-row
          >
        </v-card>
      </section>

      <section id="contact" class="mt-16 mb-16 landing-section contact-section">
        <v-row justify="center">
          <v-col cols="10">
            <v-row>
              <v-col cols="12" sm="5">
                <h1>{{ $t("contactUs") }}</h1>
                <h4 class="font-weight-light mt-3">
                  {{ this.settingsObj.contactUsText }}
                </h4>
                <h4 class="font-weight-light mt-3">
                  {{ $t("telephone") }}:
                  {{ this.settingsObj.contactUsTelephone }}
                </h4>
                <h4 class="font-weight-light">
                  {{ $t("email") }}: {{ this.settingsObj.contactUsEmail }}
                </h4>
              </v-col>
              <v-col cols="12" sm="7">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    :label="$t('name')"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    :label="$t('email')"
                    required
                  ></v-text-field>

                  <v-textarea
                    v-model="textArea"
                    :rules="textAreaRules"
                    :label="$t('message')"
                    required
                  />

                  <v-btn
                    :disabled="!valid"
                    color="primary"
                    :dark="valid"
                    rounded
                    block
                    class="mt-3"
                    @click="submit"
                  >
                    {{ $t("submit") }}
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>
    </v-main>
    <v-footer dark padless class="landing-footer">
      <v-card flat tile width="100%" class="text-center">
        <v-card-text>
          <v-btn
            v-for="icon in icons"
            :key="icon.img"
            :href="icon.route"
            class="mx-4 white--text"
            icon
          >
            <v-icon size="24px">
              {{ icon.img }}
            </v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text class="pt-0">
          {{ this.settingsObj.footerText }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>{{ this.siteName }}</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import config from "../../../public/config";
import Message from "../../components/common/Message";
import i18n from "@/plugins/i18n";

export default {
  name: "Landing",
  components: { Message },
  data() {
    return {
      drawer: null,
      isXs: false,
      activeSection: "",
      itemsPlan: [],
      items: [
        ["mdi-home-outline", "Home", "#home"],
        ["monetization_on", "Pricing", "#pricing"],
        ["featured_play_list", "Features", "#features"],
        ["contact_support", "Contact", "#contact"],
      ],
      icons: [
        { img: "mdi-facebook", text: "facebook", route: "" },
        { img: "mdi-twitter", text: "youtube", route: "" },
        { img: "mdi-linkedin", text: "linkedin", route: "" },
        { img: "mdi-instagram", text: "instagram", route: "" },
      ],
      logoPath: "",
      homeImg: window.location.origin + "/upload/home.jpg",
      feature1: window.location.origin + "/upload/feature1.jpg",
      feature2: window.location.origin + "/upload/feature2.webp",
      feature3: window.location.origin + "/upload/feature3.webp",
      feature4: window.location.origin + "/upload/feature4.jpg",
      siteName: "",
      defaultLogoUrl:
        window.location.origin + "/upload/logo-quick-test-black.png",
      valid: true,
      name: "",
      nameRules: [
        (v) => !!v || "Name can not be empty",
        (v) =>
          (v && v.length >= 6) ||
          "Length must be greater than or equal to 6 caracteres",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "Email can not be empty",
        (v) => /.+@.+\..+/.test(v) || "Wrong Email!",
      ],
      textArea: "",
      textAreaRules: [
        (v) => !!v || "Message can not be empty",
        (v) =>
          (v && v.length >= 10) ||
          "Length must be greater than or equal to 10 caracteres",
      ],
      lazy: false,
      settingsObj: {},
    };
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    navigateToSection(section) {
      this.activeSection = section;
      this.$vuetify.goTo(`#${section}`);
    },
    switchSignIn() {
      this.$router.push({ name: "SignIn" });
    },
    initializePlan() {
      this.$store
        .dispatch("settings/fetchBillingPlans")
        .then((response) => {
          //.log("billing plans", response.data);
          this.itemsPlan = response.data;
        })
        .catch((err) => {
          console.log(err);
          this.$router.push({ name: "NoInternet" });
        });
    },
    initializeText() {
      this.$store
        .dispatch("settings/fetchSiteSettings")
        .then((response) => {
          //console.log(response.data);
          this.settingsObj = response.data;
          this.icons[0].route = this.settingsObj.footerFacebook;
          this.icons[1].route = this.settingsObj.footerTwitter;
          this.icons[2].route = this.settingsObj.footerLinkedin;
          this.icons[3].route = this.settingsObj.footerInstagram;
        })
        .catch((err) => {
          console.log(err);
          this.$router.push({ name: "NoInternet" });
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        const obj = {
          name: this.name,
          email: this.email,
          message: this.textArea,
        };
        this.$store
          .dispatch("settings/createContacts", obj)
          .then((response) => {
            if (response.status == 200) {
              this.$root.$emit(
                "message_from_parent",
                this.$t(response.data.responseMsg),
              );
            } else if (response.status == 202) {
              this.$root.$emit(
                "message_from_parent_long",
                this.$t(response.data.responseMsg),
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    saveBillingPlan(item) {
      localStorage.setItem("billingPlanId", item.billingPlanId);
      localStorage.setItem("billingPlanPrice", item.price);
      if (item.price == 0) {
        this.$router.push({ name: "SignIn" });
      }
    },
    updateClientUrl() {
      const obj = {
        displayName: window.location.origin,
      };
      this.$store.dispatch("settings/updateClientUrl", obj);
    },
  },
  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  computed: {
    stripePostUrl() {
      return config.hostname + "/payment/create-checkout-session-plan";
    },
    stripeKey() {
      return this.settingsObj.stripeSecretKey;
    },
    getHomeImg: function() {
      return config.hostname + this.settingsObj.homePicture;
    },
    getFeature1Img: function() {
      return config.hostname + this.settingsObj.feature1Picture;
    },
    getFeature2Img: function() {
      return config.hostname + this.settingsObj.feature2Picture;
    },
    getFeature3Img: function() {
      return config.hostname + this.settingsObj.feature3Picture;
    },
    getFeature4Img: function() {
      return config.hostname + this.settingsObj.feature4Picture;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created() {
    i18n.locale =
      localStorage.getItem("language") == null ||
      localStorage.getItem("language") == ""
        ? "en"
        : localStorage.getItem("language");
    this.$store.dispatch("dashboard/signOut");
    this.logoPath =
      this.$store.getters["settings/logoPath"] == ""
        ? this.defaultLogoUrl
        : config.hostname + this.$store.getters["settings/logoPath"];
    this.siteName =
      this.$store.getters["settings/siteTitle"] == ""
        ? "Assess"
        : this.$store.getters["settings/siteTitle"];
    this.initializePlan();
    this.initializeText();
    this.updateClientUrl();
  },
};
</script>
<style scoped>
.landing-page {
  --ink: #17233e;
  --muted: #66738c;
  --accent: #10b7a2;
  --accent-dark: #087f78;
  background: #f5f7fb;
  color: var(--ink);
}

.landing-app-bar {
  background: rgba(255, 255, 255, 0.97) !important;
  border-bottom: 1px solid #e9edf4;
}

.landing-drawer {
  background: linear-gradient(
    165deg,
    #14213d 0%,
    #1d3655 72%,
    #087f78 150%
  ) !important;
}

.landing-drawer ::v-deep .v-divider {
  border-color: rgba(255, 255, 255, 0.14);
}

.landing-drawer ::v-deep .v-list-item__title,
.landing-drawer ::v-deep .v-icon {
  color: rgba(255, 255, 255, 0.88);
}

.landing-drawer ::v-deep .v-list-item:hover::before {
  background: #10b7a2;
  opacity: 0.14;
}

.landing-app-bar .v-btn {
  color: var(--ink);
  font-weight: 600;
  letter-spacing: 0;
}

.landing-app-bar .landing-sign-in {
  border-color: #d8e4e8;
  border-radius: 12px;
  color: var(--accent-dark);
}

.landing-app-bar .landing-nav-link.nav-link-active {
  border-radius: 12px;
  background: #e3f7f3;
  color: var(--accent-dark) !important;
}

.landing-home {
  overflow: hidden;
  padding-bottom: 42px;
  background: radial-gradient(
      ellipse at 88% 12%,
      rgba(16, 183, 162, 0.1),
      transparent 30%
    ),
    #f5f7fb;
}

.landing-hero {
  position: relative;
  overflow: hidden;
  align-items: center;
  min-height: 490px;
  margin: 0 0 84px !important;
  padding: 62px 0;
  border-radius: 0 0 44px 44px;
  background: linear-gradient(120deg, #14213d 0%, #1d3655 60%, #087f78 130%);
  box-shadow: 0 24px 60px rgba(21, 39, 68, 0.17);
}

.landing-hero::after {
  position: absolute;
  right: -90px;
  bottom: -210px;
  width: 460px;
  height: 460px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  box-shadow: 0 0 0 35px rgba(255, 255, 255, 0.025),
    0 0 0 75px rgba(255, 255, 255, 0.025);
  content: "";
  pointer-events: none;
}

.landing-hero > .col {
  z-index: 1;
}

.header {
  margin-bottom: 24px;
  color: var(--ink);
  font-size: clamp(2.4rem, 5vw, 4.25rem);
  font-weight: 800;
  letter-spacing: -0.055em;
  line-height: 1.08;
}

.landing-hero .header {
  color: #fff;
}

.bodyText {
  margin-bottom: 30px;
  color: var(--muted);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.8;
}

.landing-hero .bodyText {
  max-width: 540px;
  color: rgba(255, 255, 255, 0.78);
}

.landing-hero .v-btn {
  min-height: 48px;
  padding: 0 26px;
  border: 0;
  border-radius: 14px;
  background: var(--accent);
  color: #092c39;
  font-weight: 700;
  letter-spacing: 0;
  box-shadow: 0 10px 28px rgba(16, 183, 162, 0.25);
}

.landing-hero .v-image {
  overflow: hidden;
  border: 7px solid rgba(255, 255, 255, 0.12);
  border-radius: 26px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.24);
}

.home-intro-title {
  margin: 0 auto 4px;
}

.home-intro-title .header {
  font-size: clamp(2rem, 4vw, 3rem);
}

.home-intro-detail .bodyText {
  max-width: 780px;
  margin: 0 auto;
}

.home-highlights {
  margin-top: 50px !important;
  margin-bottom: 30px !important;
}

.highlight-card {
  height: 100%;
  overflow: hidden;
  border: 1px solid #e7ecf3;
  border-radius: 20px !important;
  background: #fff;
  box-shadow: 0 12px 32px rgba(25, 42, 70, 0.07) !important;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.highlight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 18px 38px rgba(25, 42, 70, 0.12) !important;
}

.highlight-title {
  min-height: 72px;
  padding: 18px;
  background: #eaf8f6;
  color: var(--accent-dark) !important;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
}

.highlight-card .v-card__text {
  padding: 22px;
  color: var(--muted);
  line-height: 1.7;
}

.landing-section {
  padding-top: 56px;
  padding-bottom: 56px;
}

.pricing-section {
  background: #fff;
}

.pricing-card {
  height: 100%;
  overflow: hidden;
  border: 1px solid #e8edf4 !important;
  border-radius: 24px !important;
  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);
  box-shadow: 0 16px 40px rgba(25, 42, 70, 0.08) !important;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.pricing-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 22px 48px rgba(25, 42, 70, 0.14) !important;
}

.pricing-card .v-card__title {
  color: var(--ink);
  font-size: 1.35rem;
  font-weight: 750;
}

.pricing-card .v-card__subtitle {
  color: var(--muted);
}

.pricing-card .v-avatar {
  background: #e3f7f3 !important;
}

.pricing-card .v-avatar span {
  color: var(--accent-dark) !important;
  font-weight: 800;
}

.pricing-card .v-card__text .row {
  min-height: 48px;
  align-items: center;
  padding: 10px 4px;
  color: var(--muted) !important;
  text-align: center;
}

.pricing-card .v-divider {
  border-color: #edf0f5;
}

.pricing-card .v-card__actions {
  padding: 18px 24px 26px;
}

.pricing-card .v-btn {
  min-width: 148px;
  min-height: 44px;
  border: 0;
  border-radius: 13px;
  background: var(--accent);
  color: #073740;
  font-weight: 700;
  letter-spacing: 0;
}

.feature-section {
  padding-top: 40px;
}

.feature-row {
  align-items: center;
  margin: 22px 0 !important;
  padding: 20px 16px;
  border-radius: 28px;
}

.feature-row:nth-child(even) {
  background: #fff;
  box-shadow: 0 12px 34px rgba(25, 42, 70, 0.055);
}

.feature-row .headerFeature {
  margin: 0;
  color: var(--ink);
  font-size: clamp(1.55rem, 3vw, 2.35rem);
  font-weight: 750;
  letter-spacing: -0.035em;
  line-height: 1.2;
  white-space: pre-wrap;
  word-break: break-word;
}

.feature-row .v-card__subtitle {
  padding-top: 4px;
  color: var(--muted);
  font-size: 1rem;
  line-height: 1.8;
}

.feature-row .v-image {
  overflow: hidden;
  border-radius: 22px;
}

.landing-cta {
  padding: 12px 8.333%;
}

.cta-card {
  overflow: hidden;
  border-radius: 28px !important;
  background: linear-gradient(
    115deg,
    #14213d 0%,
    #1d3655 62%,
    #087f78 140%
  ) !important;
  box-shadow: 0 22px 54px rgba(21, 39, 68, 0.18) !important;
}

.cta-card .v-card__text {
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  font-weight: 700;
}

.cta-card .v-btn {
  min-height: 46px;
  padding: 0 25px;
  border: 0;
  border-radius: 13px;
  background: var(--accent);
  color: #092c39;
  font-weight: 700;
  letter-spacing: 0;
}

.contact-section {
  padding-top: 72px;
  padding-bottom: 78px;
  background: #fff;
}

.contact-section h1 {
  color: var(--ink);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  letter-spacing: -0.045em;
}

.contact-section h4 {
  color: var(--muted);
  line-height: 1.7;
}

.contact-section .v-input {
  margin-bottom: 12px;
}

.contact-section .v-input__control {
  border-radius: 13px;
}

.contact-section .v-btn {
  min-height: 48px;
  border-radius: 13px;
  background: var(--accent) !important;
  color: #073740;
  font-weight: 700;
  letter-spacing: 0;
}

.landing-footer {
  background: #14213d !important;
}

.landing-footer .v-card {
  background: transparent;
}

.landing-footer .v-card__text {
  color: rgba(255, 255, 255, 0.78);
}

@media (max-width: 959px) {
  .landing-hero {
    min-height: 0;
    margin-bottom: 56px !important;
    padding: 48px 0;
    border-radius: 0 0 32px 32px;
  }

  .landing-hero .v-image {
    margin-top: 28px;
  }

  .landing-section {
    padding-top: 34px;
    padding-bottom: 34px;
  }
}

@media (max-width: 599px) {
  .landing-hero {
    padding: 38px 0;
  }

  .landing-hero .header {
    font-size: 2.5rem;
  }

  .home-highlights {
    margin-top: 26px !important;
  }

  .feature-row {
    margin: 14px 0 !important;
    padding: 12px 4px;
  }

  .landing-cta {
    padding-right: 5%;
    padding-left: 5%;
  }

  .contact-section {
    padding-top: 48px;
    padding-bottom: 52px;
  }
}
</style>
